angular.module('impactx.search').controller('SupplierItemCtrl', [
    '$redirect',
    'AppConfiguration',
    'panelService',
    '$routeParams',
    'SearchFilterStorage',
    SupplierItemCtrl
]);

function SupplierItemCtrl($redirect, AppConfiguration, panelService, $routeParams, SearchFilterStorage) {
    var self = this;

    self.redirectToDetails = function () {
        if ($routeParams.useSetFilterList && SearchFilterStorage.getCurrentFilter()) {
            var filter = JSON.parse(JSON.stringify(SearchFilterStorage.getCurrentFilter()));
            filter.supplierId = {value: self.supplier.id};
            filter.dialogFilter = "supplier";
            SearchFilterStorage.setSupplierFilter(self.supplier.id , filter);
        }
        $redirect.redirectTo(null, "supplier/" + self.supplier.id + (($routeParams.useSetFilter || $routeParams.useSetFilterList) ? "/true" : ""));
    };

    self.showPanelLabel = AppConfiguration.get('showPanelLabels');
    self.getSupplierPanelColor = panelService.getSupplierPanelColor;
}